import { Route } from '@angular/router';
import {
  adminGuard,
  authGuard,
  lightGuard,
  normalGuard,
  operatorGuard, superAdminGuard
} from '@adlatus-gui/domain/authentication';
import { canLeavePageGuard } from '@adlatus-gui/shared';
import { proxySettingsGuard } from './core/guard/proxy-settings.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'Dashboard',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('./pages/main-page').then((m) => m.MainPageComponent),
  },
  {
    path: 'user',
    title: 'User',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('@adlatus-gui/shared').then((m) => m.UserProfilePageComponent),
  },
  {
    path: 'tickets/:type',
    title: 'Issues',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('./pages/tickets-page').then((m) => m.TicketsPageComponent),
  },
  {
    path: 'tickets/:type/:id',
    title: 'Single Issue',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('./pages/single-ticket-page').then(
        (m) => m.SingleTicketPageComponent
      ),
  },
  {
    path: 'clearing-data/:id',
    title: 'Add Ticket Clearing Data',
    canActivate: [normalGuard],
    canDeactivate: [canLeavePageGuard],
    loadComponent: () =>
      import('./pages/add-ticket-data-page').then(
        (m) => m.AddTicketDataPageComponent
      ),
  },
  {
    path: 'create-ticket',
    title: 'Create a Issue',
    canActivate: [operatorGuard],
    canDeactivate: [canLeavePageGuard],
    loadComponent: () =>
      import('./pages/create-ticket-page').then(
        (m) => m.CreateTicketPageComponent
      ),
  },
  {
    path: 'templates',
    title: 'Templates',
    canActivate: [operatorGuard],
    loadComponent: () =>
      import('./pages/templates-page').then((m) => m.TemplatesPageComponent),
  },
  {
    path: 'settings/roles',
    title: 'Role Management',
    canActivate: [adminGuard, proxySettingsGuard],
    loadComponent: () =>
      import('./pages/role-management-page').then(
        (m) => m.RoleManagementPageComponent
      ),
  },
  {
    path: 'settings/routing/:type',
    title: 'List Routing Configuration',
    canActivate: [adminGuard, proxySettingsGuard],
    loadComponent: () =>
      import('./pages/routing-config-page').then(
        (m) => m.RoutingConfigPageComponent
      ),
  },
  {
    path: 'settings/partner-config',
    title: 'Partnership Configuration',
    canActivate: [adminGuard, proxySettingsGuard],
    loadComponent: () =>
      import('./pages/partnership-config-page').then(
        (m) => m.PartnershipConfigPageComponent
      ),
  },
  {
    path: 'settings/routing/:type/:id',
    title: 'Single Routing Config',
    data: {
      backTo: 'settings/routing',
    },
    canActivate: [adminGuard, proxySettingsGuard],
    loadComponent: () =>
      import('./pages/single-routing-config-page').then(
        (m) => m.SingleRoutingConfigPageComponent
      ),
  },
  {
    path: 'settings/sla',
    title: 'List SLA Configuration',
    canActivate: [adminGuard, proxySettingsGuard],
    loadComponent: () =>
      import('./pages/sla-config-page').then((m) => m.SlaConfigPageComponent),
  },
  {
    path: 'help',
    title: 'Help',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('./pages/help-page').then((m) => m.HelpPageComponent),
  },
  // {
  //   path: 'release-notes',
  //   title: 'Release Notes',
  //   canActivate: [normalGuard],
  //   loadComponent: () =>
  //     import('./pages/release-notes').then((m) => m.MigrationComponent),
  // },
  {
    path: 'migration',
    title: 'Migrate Organisation',
    canActivate: [superAdminGuard],
    loadComponent: () =>
      import('./pages/migration').then((m) => m.MigrationComponent),
  },
  {
    path: 'light/tickets/:id',
    title: 'Single Issue',
    canActivate: [lightGuard],
    loadComponent: () =>
      import('./pages/single-ticket-page').then(
        (m) => m.SingleTicketPageComponent
      ),
  },
  {
    path: 'light/clearing-data/:id',
    title: 'Add Ticket Clearing Data',
    canActivate: [normalGuard],
    canDeactivate: [canLeavePageGuard],
    loadComponent: () =>
      import('./pages/add-ticket-data-page').then(
        (m) => m.AddTicketDataPageComponent
      ),
  },
  {
    path: 'light/create-ticket',
    title: 'Create a Issue',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('./pages/create-ticket-page').then(
        (m) => m.CreateTicketPageComponent
      ),
  },
  {
    path: 'light/templates',
    title: 'Templates',
    canActivate: [normalGuard],
    loadComponent: () =>
      import('./pages/templates-page').then((m) => m.TemplatesPageComponent),
  },
  {
    path: '**',
    pathMatch: 'full',
    title: 'Page Not Found',
    loadComponent: () =>
      import('@adlatus-gui/shared').then((m) => m.NotFoundPageComponent),
  },
].map((route) => ({
  ...route,
  canActivate: route.canActivate
    ? [...route.canActivate, authGuard]
    : [authGuard],
})) as Route[];
